// Finance ledger API, client side (slice 2a). Admin only, so it uses the admin apiClient: finance pages
// have no HttpClientProvider. apiClient throws an HttpError carrying the server's message on a 4xx.
import { apiClient } from "@/services/apiClient";
import type { AddedFreelancer, FreelancerInput, OwnClient, Person } from "../types";

const BASE = "/api/finance";

export const ledgerService = {
  people: () => apiClient.get<{ people: Person[] }>(`${BASE}/people`).then((r) => r.people),
  /** Adds someone outside the team to finance (TD-106). An email that already has a person links to them. */
  addPerson: (input: FreelancerInput) => apiClient.post<AddedFreelancer>(`${BASE}/people`, input),
  /** The agency's own client (TD-105), or none. */
  ownClient: () => apiClient.get<OwnClient>(`${BASE}/own-client`),
  /** Names the agency's own client, or clears it with null (TD-105). */
  setOwnClient: (clientId: string | null) => apiClient.put<OwnClient>(`${BASE}/own-client`, { clientId }),
};
